import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from './index.scss';

import heatmapOn from '../../../../assets/heatmap_on.png';
import heatmapOff from '../../../../assets/heatmap_off.png';
import graphicalOn from '../../../../assets/graphical_view_on.png';
import graphicalOff from '../../../../assets/graphical_view_off.png';
import tabularOn from '../../../../assets/tabular_view_on.png';
import tabularOff from '../../../../assets/tabular_view_off.png';

const HEATMAP_VIEW = 0;
const GRAPHICAL_VIEW = 1;
const TABULAR_VIEW = 2;

const ViewSwitcher = ({ onViewSwitchChange, activeView }) => {
  return (
    <div className={classnames('btn-group', style.buttonGroup)}>
      <button
        onClick={() => {
          onViewSwitchChange(HEATMAP_VIEW);
        }}>
        <img
          src={activeView === HEATMAP_VIEW ? heatmapOn : heatmapOff}
          alt="heatmap view"
        />
      </button>
      <button
        onClick={() => {
          onViewSwitchChange(GRAPHICAL_VIEW);
        }}>
        <img
          src={activeView === GRAPHICAL_VIEW ? graphicalOn : graphicalOff}
          alt="graphical view"
        />
      </button>
      {/* <button onClick={() => { onViewSwitchChange(TABULAR_VIEW) }}>
        <img src={activeView === TABULAR_VIEW ? tabularOn : tabularOff} alt="tabular view" />
      </button> */}
    </div>
  );
};

ViewSwitcher.propTypes = {
  activeView: PropTypes.number,
  onViewSwitchChange: PropTypes.func
};

export default ViewSwitcher;
